import { render, staticRenderFns } from "./RechargeSuccess.vue?vue&type=template&id=5d1b4ade&scoped=true&"
import script from "./RechargeSuccess.vue?vue&type=script&lang=ts&"
export * from "./RechargeSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./RechargeSuccess.vue?vue&type=style&index=0&id=5d1b4ade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b4ade",
  null
  
)

export default component.exports